import * as actionTypes from './actionTypes';

export const customFieldGroupsActions = {
    request: type => ({
        type: actionTypes.GET_CUSTOM_FIELD_GROUPS['REQUEST'],
        payload: { type },
    }),

    success: (customFieldsGroups, type) => ({
        type: actionTypes.GET_CUSTOM_FIELD_GROUPS['SUCCESS'],
        payload: { customFieldsGroups, type },
    }),

    failure: (error, type) => ({
        type: actionTypes.GET_CUSTOM_FIELD_GROUPS['FAILURE'],
        payload: { error, type },
    }),
};
